import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0766fc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = { class: "breadcrumb-item active" }
const _hoisted_6 = { "aria-current": "location" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_11 = {
  key: 0,
  class: "card mb-4"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Manage post", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "d-flex flex-column align-items-start" }
const _hoisted_16 = {
  key: 1,
  class: "card"
}
const _hoisted_17 = { class: "card-body related" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Recent posts:", -1))
const _hoisted_21 = { class: "list-group list-group-flush" }
const _hoisted_22 = { class: "list-group-item" }
const _hoisted_23 = { class: "card mt-5" }
const _hoisted_24 = {
  class: "card-body",
  style: {"min-height":"150px"}
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_icon = _resolveComponent("icon")
  const _component_spinner = _resolveComponent("spinner")

  return ($setup.post)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["MetaTag"], {
          name: "og:title",
          content: $setup.post.title
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          name: "og:url",
          content: $setup.endpoints.main(`/view/${$setup.post.id}`)
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          name: "og:image",
          content: $setup.post.thumbnail
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          names: ['og:description', 'description'],
          content: $setup.stub($setup.post.renderedbody)
        }, null, 8, ["content"]),
        _createVNode($setup["LinkTag"], {
          rel: "canonical",
          href: $setup.endpoints.main(`/view/${$setup.post.id}/${$setup.post.uglytitle}`)
        }, null, 8, ["href"]),
        _createVNode($setup["FeedTag"], {
          "object-id": $setup.post.id
        }, null, 8, ["object-id"]),
        _createVNode($setup["TitleTag"], {
          title: $setup.post.title
        }, null, 8, ["title"]),
        _createElementVNode("ol", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, { to: {name:'forums'} }, {
              default: _withCtx(() => [
                _createTextVNode("Forums")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: {name:'forum', params:{id:$setup.post.forumid}}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.post.forum?.title), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString($setup.post.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass({'col-lg-9': $setup.showSidebar, 'col-lg-12': !$setup.showSidebar})
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode($setup["PostView"], {
                  post: $setup.post,
                  editing: $setup.editing,
                  onFinishedEdit: _cache[0] || (_cache[0] = $event => ($setup.editing = false))
                }, null, 8, ["post", "editing"])
              ])
            ])
          ], 2),
          ($setup.showSidebar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                ($setup.showManage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          ($setup.canEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-info",
                                onClick: _cache[1] || (_cache[1] = $event => ($setup.editing = true))
                              }, [
                                _createVNode(_component_icon, {
                                  class: "me-2",
                                  icon: "edit",
                                  "fixed-width": "fixed-width"
                                }),
                                _createTextVNode("Edit post")
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.canDelete)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-danger mt-2",
                                onClick: $setup.deletePost
                              }, [
                                _createVNode(_component_icon, {
                                  class: "me-2",
                                  icon: "trash",
                                  "fixed-width": "fixed-width"
                                }),
                                _createTextVNode("Delete post")
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.canMovePost)
                            ? (_openBlock(), _createBlock($setup["MovePostButton"], {
                                key: 2,
                                class: "mt-2",
                                post: $setup.post,
                                onMoved: $setup.movedTo
                              }, null, 8, ["post"]))
                            : _createCommentVNode("", true),
                          ($setup.canSendNewsletter)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 3,
                                class: "btn btn-success mt-2",
                                to: $setup.newsletterRoute
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icon, {
                                    class: "me-2",
                                    icon: "envelope",
                                    "fixed-width": "fixed-width"
                                  }),
                                  _createTextVNode("Send newsletter")
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.showRelated)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("a", {
                          class: "float-end text-decoration-none hide-link",
                          href: "#",
                          "aria-label": "Close",
                          onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($setup.showRelated = false), ["prevent"]))
                        }, _hoisted_19),
                        _hoisted_20,
                        _createElementVNode("ul", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.post.related, (item) => {
                            return (_openBlock(), _createElementBlock("li", _hoisted_22, [
                              _createVNode(_component_router_link, {
                                class: "stretched-link",
                                to: {name:'post', params: {id:item.id}}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 256))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
              fallback: _withCtx(() => [
                _createVNode(_component_spinner)
              ]),
              default: _withCtx(() => [
                _createVNode($setup["CommentList"], {
                  objectid: $setup.post.id
                }, null, 8, ["objectid"])
              ]),
              _: 1
            }))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}